import { createSelector } from "reselect";

import { getSaleStatuses } from "../root";

export const selectSaleStatusesAggridData = createSelector(
  [getSaleStatuses],
  (saleStatusesByIdLookup: SaleStatus[]) =>
    Object.values(saleStatusesByIdLookup),
);
